import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthWrapper } from './authWrapper'

createRoot( document.getElementById( 'root' )! ).render( <StrictMode>
	<AuthWrapper />
</StrictMode> )
